<template>
  <div>
    <div
      style="position: fixed; top: 20px; z-index: 6; backdrop-filter: blur(2px)"
      v-if="LoaderStatus"
    >
      <Spinner />
    </div>
    <div class="main-container bluebtn">
      <div class="cf-header-2 d-flex align-items-center">
        <img
          :class="showResumeLoader ? 'opacity-50' : 'pointer'"
          src="../../assets/customfield/blueBackArrow.svg"
          class="mr-3"
          @click="!showResumeLoader && goBackPointer()"
          alt=""
        />
        <div>
          {{ $route.name == "EditCandidate" ? "Edit" : "Activate" }} Candidate
        </div>
      </div>
      <FormShimmer v-if="shimmerLoader" />
      <template v-else>
        <div
          class="
            mt-3
            teams-main-container
            custField-main-height
            relativeclass
            forminputs
            w-100
            p-0
          "
        >
          <div class="h-100">
            <div
              style="
                height: 90%;
                overflow-x: hidden;
                overflow-y: auto;
                padding: 5px 200px;
              "
            >
              <b-row>
                <b-col
                  v-for="(field, index) in basicArray"
                  :key="index"
                  :cols="getColumn(field.controlType)"
                  class="relativeclass mt-2"
                  :class="
                    field.controlType == 'boolean'
                      ? 'd-flex align-items-center'
                      : ''
                  "
                  v-show="!field.hide"
                >
                  <div
                    v-if="
                      field.controlType == 'text' ||
                      field.controlType == 'email' ||
                      field.controlType == 'number'
                    "
                    class="topDiv mt-3"
                  >
                    <InputField
                      :type="field.controlType"
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      @select-value="updateFieldValue(field, $event)"
                      @handle-input="handleInput(field)"
                      @handle-blur="handleBlur(field)"
                      :showError="getError(field)"
                      :vmodel="getVmodel(field)"
                    />
                  </div>

                  <div
                    v-else-if="field.controlType == 'single_select'"
                    class="topDiv mt-3"
                  >
                    <SelectCustom
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      :api="field.apiEndpoint"
                      :values="field.values"
                      :dropdown="field.dropdown"
                      :fieldType="field.fieldType"
                      @select-value="updateFieldValue(field, $event)"
                      :showError="getError(field)"
                      :vmodel="getVmodel(field)"
                    />
                  </div>

                  <div
                    v-else-if="field.controlType == 'multi_select'"
                    class="topDiv mt-3"
                  >
                    <MultiSelectCustom
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      :api="field.apiEndpoint"
                      :values="field.values"
                      :dropdown="field.dropdown"
                      :fieldType="field.fieldType"
                      @select-value="updateFieldValue(field, $event)"
                      :showError="getError(field)"
                      :vmodel="getVmodel(field)"
                    />
                  </div>
                  <div
                    v-else-if="field.controlType == 'rich_text_box'"
                    class="topDiv mt-3"
                  >
                    <CustomQuillEditor
                      :type="field.controlType"
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      @select-value="updateFieldValue(field, $event)"
                      @handle-input="handleInput(field)"
                      @handle-blur="handleBlur(field)"
                      :showError="getError(field)"
                      :vmodel="getVmodel(field)"
                    />
                  </div>
                  <div
                    v-else-if="field.controlType == 'boolean'"
                    class="topDiv mt-4"
                  >
                    <SwitchBox
                      :type="field.controlType"
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      @select-value="updateFieldValue(field, $event)"
                      :vmodel="getVmodel(field)"
                    />
                  </div>

                  <div
                    v-else-if="field.controlType == 'upload_file'"
                    class="topDiv mt-3"
                  >
                    <UploadDocument
                      :type="field.controlType"
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      :fileFormat="field.fileFormat"
                      :showError="getError(field)"
                      :maxFileSize="field.maxFileSize"
                      :vmodel="getVmodel(field)"
                      @select-value="updateFieldValue(field, $event)"
                      @reupload-value="field.isReupload = true"
                      :showResumeLoader="showResumeLoader"
                    />
                  </div>
                  <div
                    v-else-if="field.controlType == 'multi_text'"
                    class="topDiv mt-3"
                  >
                    <FormTags
                      :type="field.controlType"
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      @select-value="updateFieldValue(field, $event)"
                      :fileFormat="field.fileFormat"
                      :showError="getError(field)"
                      :maxLength="parseInt(field.limit)"
                      :vmodel="getVmodel(field)"
                      @length-error="setLengthError($event, field)"
                      @handle-input="handleInput(field)"
                      @handle-blur="handleBlur(field)"
                    />
                  </div>
                  <div
                    v-else-if="field.controlType == 'date'"
                    class="topDiv mt-3"
                  >
                    <DateField
                      :type="field.controlType"
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      @select-value="updateFieldValue(field, $event)"
                      :showError="getError(field)"
                      :format="field.dateTimeFormat"
                      :vmodel="getVmodel(field)"
                    />
                  </div>

                  <template
                    v-if="touchedFields[field.key] && !lengthError[field.key]"
                  >
                    <div
                      class="newInt-required-validation-font mt-1"
                      v-if="field.mandatory && !validateField(field)"
                    >
                      {{ valText[field.key] }}
                    </div>
                    <div
                      class="newInt-required-validation-font mt-1"
                      v-else-if="field.limit > 0 && !validateField(field)"
                    >
                      {{ valText[field.key] }}
                    </div>
                  </template>
                </b-col>
              </b-row>
              <div
                class="d-flex align-items-center mt-4"
                v-if="advanceArray.length > 0"
              >
                <div @click="showAdvance = !showAdvance">
                  <img
                    v-if="showAdvance"
                    src="../../assets/customfield/modalTopArrow.svg"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../assets/customfield/modalDownArrow.svg"
                    alt=""
                  />
                </div>
                <div class="cs-bluetxt ml-2 mr-3">Advanced</div>
                <div class="modal-horizontal-line"></div>
              </div>
              <b-row v-if="showAdvance">
                <b-col
                  v-for="(field, index) in advanceArray"
                  :key="index"
                  :cols="getColumn(field.controlType)"
                  class="relativeclass mt-2"
                  :class="
                    field.controlType == 'boolean'
                      ? 'd-flex align-items-center'
                      : ''
                  "
                  v-show="!field.hide"
                >
                  <div
                    v-if="
                      field.controlType == 'text' ||
                      field.controlType == 'email' ||
                      field.controlType == 'number'
                    "
                    class="topDiv mt-3"
                  >
                    <InputField
                      :type="field.controlType"
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      @select-value="updateFieldValue(field, $event)"
                      @handle-input="handleInput(field)"
                      @handle-blur="handleBlur(field)"
                      :showError="getError(field)"
                      :vmodel="getVmodel(field)"
                    />
                  </div>

                  <div
                    v-else-if="field.controlType == 'single_select'"
                    class="topDiv mt-3"
                  >
                    <SelectCustom
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      :api="field.apiEndpoint"
                      :values="field.values"
                      :dropdown="field.dropdown"
                      :fieldType="field.fieldType"
                      @select-value="updateFieldValue(field, $event)"
                      :showError="getError(field)"
                      :vmodel="getVmodel(field)"
                    />
                  </div>

                  <div
                    v-else-if="field.controlType == 'multi_select'"
                    class="topDiv mt-3"
                  >
                    <MultiSelectCustom
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      :api="field.apiEndpoint"
                      :values="field.values"
                      :dropdown="field.dropdown"
                      :fieldType="field.fieldType"
                      @select-value="updateFieldValue(field, $event)"
                      :showError="getError(field)"
                      :vmodel="getVmodel(field)"
                    />
                  </div>
                  <div
                    v-else-if="field.controlType == 'rich_text_box'"
                    class="topDiv mt-3"
                  >
                    <CustomQuillEditor
                      :type="field.controlType"
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      @select-value="updateFieldValue(field, $event)"
                      @handle-input="handleInput(field)"
                      @handle-blur="handleBlur(field)"
                      :showError="getError(field)"
                      :vmodel="getVmodel(field)"
                    />
                  </div>
                  <div
                    v-else-if="field.controlType == 'boolean'"
                    class="topDiv mt-4"
                  >
                    <SwitchBox
                      :type="field.controlType"
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      @select-value="updateFieldValue(field, $event)"
                      :vmodel="getVmodel(field)"
                    />
                  </div>

                  <div
                    v-else-if="field.controlType == 'upload_file'"
                    class="topDiv mt-3"
                  >
                    <UploadDocument
                      :type="field.controlType"
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      @select-value="updateFieldValue(field, $event)"
                      @reupload-value="field.isReupload = true"
                      :fileFormat="field.fileFormat"
                      :showError="getError(field)"
                      :maxFileSize="field.maxFileSize"
                      :vmodel="getVmodel(field)"
                    />
                  </div>
                  <div
                    v-else-if="field.controlType == 'multi_text'"
                    class="topDiv mt-3"
                  >
                    <FormTags
                      :type="field.controlType"
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      @select-value="updateFieldValue(field, $event)"
                      :fileFormat="field.fileFormat"
                      :showError="getError(field)"
                      :maxLength="parseInt(field.limit)"
                      :vmodel="getVmodel(field)"
                      @length-error="setLengthError($event, field)"
                      @handle-input="handleInput(field)"
                      @handle-blur="handleBlur(field)"
                    />
                  </div>
                  <div
                    v-else-if="field.controlType == 'date'"
                    class="topDiv mt-3"
                  >
                    <DateField
                      :type="field.controlType"
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      @select-value="updateFieldValue(field, $event)"
                      :showError="getError(field)"
                      :format="field.dateTimeFormat"
                      :vmodel="getVmodel(field)"
                    />
                  </div>

                  <template
                    v-if="touchedFields[field.key] && !lengthError[field.key]"
                  >
                    <div
                      class="newInt-required-validation-font mt-1"
                      v-if="field.mandatory && !validateField(field)"
                    >
                      {{ valText[field.key] }}
                    </div>
                    <div
                      class="newInt-required-validation-font mt-1"
                      v-else-if="field.limit > 0 && !validateField(field)"
                    >
                      {{ valText[field.key] }}
                    </div>
                  </template>
                </b-col>
              </b-row>
            </div>
            <div
              style="height: 10%"
              class="
                newInt-footer
                d-flex
                align-items-center
                justify-content-end
                w-100
                bluebtn
              "
            >
              <b-button
                class="acs-cancelBtn-modal mr-3"
                :disabled="showResumeLoader"
                @click="goBackPointer"
                >Cancel</b-button
              >
              <div class="relativeclass">
                <b-button
                  class="acs-addBtn-modal"
                  :class="{
                    pointer: !LoaderStatus,
                  }"
                  @click="LoaderStatus ? '' : validateForm()"
                  :disabled="showResumeLoader"
                >
                  {{ $route.name == "EditCandidate" ? "Update" : "Activate" }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </template>
      <ConfirmModal
        @handle-submit="applyParsedData"
        button="Continue"
        header="Warning"
        msg="Are you sure? Do you want to replace the existing data with the parsed resume details?"
        :imageSrc="require('../../assets/img/feedbackform/confirmIcon.svg')"
      />
    </div>
  </div>
</template>

<script>
import newCandidateMixin from "../../components/mixin/newCandidateMixin";
export default {
  name: "AddCandidate",
  mixins: [newCandidateMixin],
  data() {
    return {
      showAdvance: true,
    };
  },
};
</script>
